import i18n from 'i18next'
/** The subset of the app's select-option shape this model needs. */
interface ISelectOption {
  value: string
  label: string
  hidden: boolean
  disable?: boolean
  group?: string
}

export interface DisplayableUser {
  email?: string
  identifier: string
  familyName?: string
  displayName: string
  givenName?: string
  color?: string
  enabled?: boolean
  active?: boolean
}

let CURRENT_USER: (DisplayableUser & ISelectOption) | undefined

export function getCurrentUser() {
  if (!CURRENT_USER) {
    CURRENT_USER = {
      identifier: '${currentUser}',
      familyName: i18n.t('common.currentUser'),
      givenName: '',
      color: 'rgb(117, 117, 117)',
      displayName: i18n.t('common.currentUser'),
      label: i18n.t('common.currentUser'),
      group: 'none',
      value: '${currentUser}',
      hidden: false,
      enabled: true,
      disable: false,
      active: true,
    }
  }
  return CURRENT_USER
}
